module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerintro01",
      "epub:type": "introduction",
      "id": "intro",
      "role": "doc-introduction"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerintro01"
    }
  }, [_c('h1', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "p1",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0006#toc"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p1"
    }
  }), _vm._v("On December 9, 2019, Colonel Douglas Burgher of the United States Army Corp of Engineers made a presentation to an eager public, in a large auditorium at the Long Beach Aquarium. In it, he announced that the Army Corps (USACE), which oversees shoreline management, was making a series of unexpected recommendations about the future of the harbor that contains the aquarium as well as the Ports of Los Angeles and Long Beach, major oil facilities, including extraction, refining, and shipping, and US military operations. He said that the US military, one of the biggest consumers of fossil fuel on the planet, was moving to implement swiftly a plan for “greening” itself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en8",
      "id": "en8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])]), _vm._v(" This was not mere “greenwashing” or an environmentally-friendly public relations spin; the service would soon cancel orders for weapons systems and reassign its workforce. It would instead turn toward civilian clean energy projects; remediation of toxic waste; building and maintaining domestic infrastructure for not only human but wildlife benefit; auditing goods and infrastructure supply chains for transspecies justice; repairing ecologies along the coast and inland; and it would withdraw from bases across the globe. This ambitious plan would lead to a clean break with fossil fuels and to a rebalanced economic strategy, which was expected to strengthen international relationships and promote global stability without military force.")]), _vm._v(" "), _c('p', [_vm._v("Locally, these effects would be felt nearly immediately. Colonel Burgher pledged that USACE would dismantle some of the San Pedro Bay breakwaters, long lines of rock which keep wave energy low so that ships in the LA harbor can load and unload mercantile cargo and even ordnance with ease. (Breakwater removal excited local surfers especially.) This was possible because the port complex was anticipated to scale down operations. "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "2",
      "epub:type": "pagebreak",
      "id": "p2",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Commercial shipping traffic would decline substantially, so more of the area could be used for other things, like ecology-tending apprenticeships and nonmotorized recreation. He announced that local stewardship of San Pedro Bay would be turned over to a civilian task force comprised of local residents whose mandate was to prioritize ecological justice; it would include schoolteachers, abalone divers, dockworkers, amateur seahorse enthusiasts, and researchers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en9",
      "id": "en9r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])]), _vm._v(" A separate council with equal say in governance matters, and veto power, would be appointed immediately by Indigenous Gabrielino (Tongva, Kizh) residents.")]), _vm._v(" "), _c('p', [_vm._v("One of the first tasks would be to cap, seal, decontaminate, and dismantle or recommission all the leftover petroleum infrastructure that the oil industry had hastily abandoned following this commodity’s sudden plunge into the red."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en10",
      "id": "en10r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])]), _vm._v(" Fortunately the industry had been compelled to leave behind a large fund for these measures, and the State of California was standing by to oversee the transfer of payments, with enforcement power if needed."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en11",
      "id": "en11r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])]), _vm._v(" After Colonel Burgher’s presentation, people spilled excitedly out into the evening, chattering about the harbor plans; the faint singing of red and white abalone could also be heard on the evening breeze."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en12",
      "id": "en12r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])]), _vm._v(" The harbor, whose shifting shores had over the last century contained a Coney Island–style amusement park and sea bath, an air strip along the beach, man-made “islands” whose palm trees and garish lighting disguised oil extraction activities, and a navy shipyard as well as the ports, would be transformed once again. And not a moment too soon, as sea level rise threatened the coast, the US empire inflamed geopolitical tensions and promoted domestic inequities, and poor air quality, heat waves, and myriad social vulnerabilities plagued the region."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en13",
      "id": "en13r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', [_vm._v("No. That didn’t happen. And it is the only part of this book that is fiction."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en14",
      "id": "en14r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])]), _vm._v(" The thing about fiction is, it has to be believable.")]), _vm._v(" "), _c('p', [_vm._v("The description of the harbor is accurate. But what actually happened in the December 2019 USACE presentation at the Aquarium of the Pacific was a much more modest recommendation, to restore eelgrass and kelp in open water and build some “rocky reef” habitat for fish and other aquatic animals. USACE proposed wildlife habitat restoration in only the eastern (Long Beach) side of San Pedro Bay, having declared the western side (port complex) off limits, because of crucial maritime operations. USACE’s entire analysis of the area, and thus the plan it set forth, began from the premise that commercial and military maritime activity as well as oil operations were "), _c('i', [_vm._v("not")]), _vm._v(" to be interrupted in any way. Very few members of the public attended the presentation, on a dark Monday evening, and the ones who did seemed disappointed, surfers included.")]), _vm._v(" "), _c('p', [_vm._v("Would it be more believable to claim that the US Navy once trained "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "3",
      "epub:type": "pagebreak",
      "id": "p3",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a dolphin to deliver mail to men living on the seabed, in an experimental aquatic habitat mirroring fantasies of colonizing space? Or that after a failed forced relocation of sea otters to a remote island, wildlife managers concerned about the prospect of otters being annihilated by spilled oil began a program in which orphaned pups were raised in captivity by adoptive parents? These stories, however implausible, are true. I present a series of multispecies stories (including these two) about San Pedro Bay that juxtapose, on the one hand, a site of multitudinous life with, on the other, hyperindustrial, toxic shipping, oil, and military operations. San Pedro Bay is paradoxically home to all of this, and thus to apprehend the significance of its operations, we must consider how ecologies and infrastructure relate to one another. In the twentieth century, the environmental sciences “were and are essentially infrastructural sciences,” that is, they played a major role in planning, maintaining, and combating large infrastructural systems."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en15",
      "id": "en15r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])]), _vm._v(" To simultaneously plan and combat infrastructural projects may appear paradoxical, but essentially identical expertise is brought to bear in both, and whether this constitutes a harmonious or conflictual undertaking is not straightforward, especially in locations designed to mediate between global and local scales like this port complex."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en16",
      "id": "en16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', [_vm._v("The setting of this book is San Pedro Bay, a natural bay twenty-odd miles straight south from downtown Los Angeles. It contains the present-day Los Angeles River mouth, into which the ports of Long Beach and Los Angeles have been built. Invisible from much of metro Los Angeles, the ports are administered separately but are physically contiguous. The Los Angeles harbor is massively important in US trade, as something like 40 percent of the goods that enter North America do so there (other ports like New Orleans, Savannah, Oakland, Tacoma, and New York–New Jersey are also significant, but smaller in relative terms)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en17",
      "id": "en17r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])]), _vm._v(" In fact, the Port of LA’s trademarked slogan is “America’s Port.” The shallow river is not navigable by ship. Nearly a century ago it was channelized in cement; confining the river to a channel transformed acres and acres of estuarial wetlands into dry land that could be used in other ways. A prominent use is freight infrastructure: lines of rail and trucking connect the ports to distribution warehouses and ultimately to retail and consumers across the continent.")]), _vm._v(" "), _c('p', [_vm._v("San Pedro Bay sits roughly the middle of the Southern California Bight, a gentle curvature of the coastline that runs from just north of Santa Barbara (Point Conception) to Punta Colonet in Baja California, Mexico. The bight, containing the Channel Islands archipelago, is an ecotone where warm and cold Pacific waters meet and mix, so quite a variety of aquatic plants and animals live in it or transit through it along migratory routes. The area is of global significance for wildlife. But because of its history, in "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "4",
      "epub:type": "pagebreak",
      "id": "p4",
      "role": "doc-pagebreak"
    }
  }), _vm._v("San Pedro Bay, shipping and industrial uses of the land- and waterscape are in tension with wildlife habitat. According to the US Army Corps of Engineers, “the bight’s location makes it one of the most threatened biodiversity hot spots in the world.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en18",
      "id": "en18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', [_vm._v("Across four chapters, I present stories of life-forms as they live in or transit through San Pedro Bay. Each centers on a charismatic life-form: birds; bananas; sea otters; cetaceans. The “natural” inhabitants of the bay have emerged as objects of environmental knowledge and concern around whom mobilization has occurred. Bananas, meanwhile, may seem like a peculiar choice in a natural history of the area, but they too are a form of biological life that has occupied an ecological niche in the harbor’s recent history. I approach each of these subjects as enmeshed within ecologies: webs of relations within lively systems, including capital and petroleum. I am concerned with wildlife management within a major industrial infrastructure project; and the history of oil in one specific locale, informed by a multispecies perspective; within the time period since the modern environmental movement in the US, which has seen both domestic environmental regulation and a steep climb in global trade and emissions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en19",
      "id": "en19r",
      "role": "doc-noteref"
    }
  }, [_vm._v("12")])]), _vm._v(" Both oil and shipping are local to San Pedro Bay but situated within vast global infrastructures, so this book is also an attempt to localize those very large topics and understand them in one specific location, albeit one which is a part of a global system. The whole of each (and certainly the whole of the whole) is constituted by a network of relations which is difficult to characterize, as it is present in many places and many levels at once."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en20",
      "id": "en20r",
      "role": "doc-noteref"
    }
  }, [_vm._v("13")])]), _vm._v(" Oil, for instance, is not only the slick you see reflected back up at you in a puddle after a rain, or the daily background smell and slight sore throat you might have as a resident of Long Beach, or your sister’s cancer diagnosis, or an acutely toxic event for an otter or an osprey, but a hardened material infrastructure of pipelines and refineries and a highly complex international governance project."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en21",
      "id": "en21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])]), _vm._v(" Here I excavate relatively small stories, unnatural histories, all sited within San Pedro Bay, which take on additional significance because of how they relate to global infrastructures of shipping, fossil fuels, and earth (sediment) moving.")]), _vm._v(" "), _c('p', [_vm._v("In spite of enormous economic and environmental impacts, San Pedro Bay’s lively and deadly history (and present) remains largely hidden from most North Americans. Even some lifelong Angelenos may be relatively oblivious to this facet of their region, as ports and container cargo occupy “the forgotten space” in globalized modernity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en22",
      "id": "en22r",
      "role": "doc-noteref"
    }
  }, [_vm._v("15")])]), _vm._v(" In 2021, as a global supply-chain crisis unfurled, media spotlighted the forgotten space: a cargo ship traffic jam in the Los Angeles harbor; bottlenecks in the flows of shipping containers; lags in goods reaching consumers. In October of "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "5",
      "epub:type": "pagebreak",
      "id": "p5",
      "role": "doc-pagebreak"
    }
  }), _vm._v("that year, a Southern California seabed oil pipeline burst, and burst into the news. Investigators of the leak suggested that its likely cause was a cargo ship’s anchor striking and dragging the pipeline, which connected an Orange County offshore drilling platform to the Port of Long Beach."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en23",
      "id": "en23r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])]), _vm._v(" Nonetheless, supply chains are generally shadowy and mystified to consumers and citizens.")]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro01"
    }
  }, [_vm._v("From Vital Infrastructure to Infrastructural Vitalism")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("This port complex, harbor, and bay require ecological thinking, in the sense of ecologies (plural) as “inextricable lines of relationality.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en24",
      "id": "en24r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])]), _vm._v(" “All living, human or not, takes place within a relational matrix,” writes anthropologist Arturo Escobar."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en25",
      "id": "en25r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])]), _vm._v(" Ecological lines of relation occur between and among living entities and nonliving infrastructural ones. The key term is relationality: to rupture a link will produce other effects, including new linkages and new ruptures. In highlighting “living entities,” I do not make an uncomplicated appeal to an essentialized “nature” or even “life.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en26",
      "id": "en26r",
      "role": "doc-noteref"
    }
  }, [_vm._v("19")])]), _vm._v(" I do however mean to draw some distinction between ecological relations favorable to flourishing biological life-forms and the relations that are constituted in what I am calling "), _c('i', [_vm._v("infrastructural vitalism")]), _vm._v(": heavily managed, industrial infrastructure which, I argue, is structured by violent logics and "), _c('i', [_vm._v("possesses a “life force” of its own")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en27",
      "id": "en27r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])]), _vm._v(" I do not mean this infrastructure literally "), _c('i', [_vm._v("is")]), _vm._v(" alive, but an animistic belief in infrastructure’s life force motivates its creators and maintainers. This belief does real work in the world—and, ironically, is often deadly for biological life.")]), _vm._v(" "), _c('p', [_vm._v("Infrastructures are “built networks that facilitate flows of people and materials necessary for sustaining society.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en28",
      "id": "en28r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])]), _vm._v(" More conceptually, infrastructures are sets of standards codified into the built environment; sites of struggle; also an often-invisible nested or stacked set of relationships, substrate upon substrate, upon which other systems are placed and fixed in increments; always relational (for example, “municipal water” is one person’s working infrastructure, at the ready for making dinner or doing wash, but another person’s maintenance job and, to the latter, not invisible)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en29",
      "id": "en29r",
      "role": "doc-noteref"
    }
  }, [_vm._v("22")])]), _vm._v(" Infrastructures exist at large scales: their time frame is historical (bigger than human lifespans; smaller than geophysical time); and they are built on large economic and social organizational scales, requiring complex organizational efforts involving entities like large firms and governments (though they are also experienced in more micro ways, and are amenable to micro, meso, and macro analysis)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en30",
      "id": "en30r",
      "role": "doc-noteref"
    }
  }, [_vm._v("23")])]), _vm._v(" The port complex in San Pedro Bay is nested within multiple infrastructures including those of freight movement and "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "6",
      "epub:type": "pagebreak",
      "id": "p6",
      "role": "doc-pagebreak"
    }
  }), _vm._v("distribution; petroleum extraction, refining, and movement; manufacture of goods; informatics and logistics related to inventory management; maritime conventions; air quality monitoring and regulation; and national security apparatus. (This is a nonexhaustive list.) It is a complex and heterogeneous node where each of those systems “fixes” itself but also mutably renews itself.")]), _vm._v(" "), _c('p', [_vm._v("In invoking "), _c('i', [_vm._v("vitalism")]), _vm._v(", I refer (loosely) to debates in history and philosophy of science over whether there is a “life force” that is not reducible to mechanistic forces or chemical reactions."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en31",
      "id": "en31r",
      "role": "doc-noteref"
    }
  }, [_vm._v("24")])]), _vm._v(" Philosophers Sebastian Normandin and Charles T. Wolfe, in examining vitalism from the late Enlightenment to the present, write that vitalism is “a moving target, an explanatory and/or metaphysical construct which appears, depending on the context, as a form of overt supernaturalism or as a useful heuristic for biomedical research and theorizing.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en32",
      "id": "en32r",
      "role": "doc-noteref"
    }
  }, [_vm._v("25")])]), _vm._v(" Conceptually, vitalism is generative, regenerative, mutable, and emergent; not fixed. My use of it here is, on the one hand, metaphorical, and certainly not (fully) literal. But it conveys something, well, vital: infrastructure gets “fixed” through a set of epistemic and material commitments, whereupon it begins to demand something like care and feeding, exhibiting the stirrings of a self-organizing system that reproduces itself, monstrously, excessively, and even cannibalistically."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en33",
      "id": "en33r",
      "role": "doc-noteref"
    }
  }, [_vm._v("26")])]), _vm._v(" Of course, it is not "), _c('i', [_vm._v("literally")]), _vm._v(" autonomous. On the other hand, because of how managers in essence "), _c('i', [_vm._v("treat ports, pipelines, and freeways as alive")]), _vm._v(" and are committed to their vitality, these animistic beliefs do work in the world. Infrastructure has momentum, even “spiritual force,” and is mutable, adaptive, lively; it is unclear who or what is in control."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en34",
      "id": "en34r",
      "role": "doc-noteref"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', [_vm._v("What is at stake in suggesting that infrastructure is possessed by vitalism? And why is this both metaphorical and, potentially, not? Take the reference (in the preface) to a freeway as the “spine” of the region. Or the common assumption that the “health” of the nation depends on the flow of commercial goods,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en35",
      "id": "en35r",
      "role": "doc-noteref"
    }
  }, [_vm._v("28")])]), _vm._v(" and even that such a flow is a “lifeblood.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en36",
      "id": "en36r",
      "role": "doc-noteref"
    }
  }, [_vm._v("29")])]), _vm._v(" “Lifeblood” and “spine” are somatic metaphors, but they are not only metaphors. They serve to "), _c('i', [_vm._v("naturalize")]), _vm._v(" the “life” of circulation. In an exploration of how deeply the notions of blood flow, blood loss, circulation, liquidity, and the like are embedded and naturalized in the conceptual vocabulary of economic relations, anthropologist Kath Weston urges going “beyond metaphorical readings of economic discourse.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en37",
      "id": "en37r",
      "role": "doc-noteref"
    }
  }, [_vm._v("30")])]), _vm._v(" In seventeenth-century England, physician William Harvey’s novel contributions to understanding the physiology of blood circulation were elaborated into economic language and concepts that “appeared to be ordered by systemic and cyclical properties . . . sometimes like water, but more often like blood.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en38",
      "id": "en38r",
      "role": "doc-noteref"
    }
  }, [_vm._v("31")])]), _vm._v(" This ascendant biological understanding of finance as circulatory coincided with "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "7",
      "epub:type": "pagebreak",
      "id": "p7",
      "role": "doc-pagebreak"
    }
  }), _vm._v("European colonization of the Americas and expansion of trade, and the linkage has endured.")]), _vm._v(" "), _c('p', [_vm._v("Later, around the turn of the twentieth century, planners and policymakers began to explicitly elevate infrastructure as a critical concern, characterizing flows of oil, water, or electricity as "), _c('i', [_vm._v("vital")]), _vm._v(" systems."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en39",
      "id": "en39r",
      "role": "doc-noteref"
    }
  }, [_vm._v("32")])]), _vm._v(" Such terms do work to build (both conceptually and literally) a set of relations imbued with a liveness, a biological imperative, central to the reproduction of capitalism and empire."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en40",
      "id": "en40r",
      "role": "doc-noteref"
    }
  }, [_vm._v("33")])]), _vm._v(" Here, I aim to "), _c('i', [_vm._v("denaturalize")]), _vm._v(" the infrastructural and economic “vitality” of a set of "), _c('i', [_vm._v("systems in which the port complex is a node")]), _vm._v(". I demonstrate how infrastructural vitalism is often in violent tension with biological life (even if the latter cannot be pointed to as an essential “nature”)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en41",
      "id": "en41r",
      "role": "doc-noteref"
    }
  }, [_vm._v("34")])]), _vm._v(" As Normandin and Wolfe write, vitalism plays a role in imagining “between . . . the dead and living.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en42",
      "id": "en42r",
      "role": "doc-noteref"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro02"
    }
  }, [_vm._v("Useless Tidal Flats? A Brief History")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 1971, port managers reflected on their stunning achievement: “Since its beginning with the dedication of the first municipal wharf in Long Beach in 1911, Port of Long Beach has, in its brief 60 year history, progressed from "), _c('i', [_vm._v("useless tidal flats")]), _vm._v(" into a major West Coast harbor.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en43",
      "id": "en43r",
      "role": "doc-noteref"
    }
  }, [_vm._v("36")])]), _vm._v(" This turn of phrase hailed the Port of Long Beach on the occasion of its sixtieth anniversary. Historian James Tejani describes the tidal flats in and around the harbor differently: “land and sea acted upon each other to construct a third space that was neither fully continent nor ocean.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en44",
      "id": "en44r",
      "role": "doc-noteref"
    }
  }, [_vm._v("37")])]), _vm._v(" But his statement supports the notion that to become a productive locale for trade, transmutation of land and sea was required. Regional managers were “dredging the future” when they sited the ports of Long Beach and Los Angeles in San Pedro Bay as part of a project to “make” Los Angeles, establishing its presence within the American West, the Pacific, and the world."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en45",
      "id": "en45r",
      "role": "doc-noteref"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', [_vm._v("Though this transformation was massive and thorough, it took just over a century; key features such as the breakwaters, lines of rock that soften wave energy near the shore, are not even a century old (a blink in geologic time, but mature in historical time)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en46",
      "id": "en46r",
      "role": "doc-noteref"
    }
  }, [_vm._v("39")])]), _vm._v(" Though the ports are composed of massive and seemingly durable structures, there has also been flux in the area as it has been built up, then rebuilt and tweaked. Inestimable tons of concrete have been poured into the port complex, most recently in erecting a new and massive bridge over the Port of Long Beach; completed in late 2020, it will accompany deeper harbor dredging to allow even bigger ships to dock (even as sea level rises), and is engineered at a higher seismic (earthquake) standard. Environmental concerns have been part of this picture especially since the 1970s, in keeping with national and state regulations, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "p8",
      "role": "doc-pagebreak"
    }
  }), _vm._v("including measuring water pollution and, more recently, air pollution in the port complex as well as rail and trucking corridors to which it connects."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en47",
      "id": "en47r",
      "role": "doc-noteref"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', [_vm._v("Prior to 1825, the Los Angeles River dispersed laterally over an “extensive wetland matrix” and downward into aquifers. During the winter rainy seasons, its runoff flowed into the Pacific Ocean at a number of places, according to memoirs and histories."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en48",
      "id": "en48r",
      "role": "doc-noteref"
    }
  }, [_vm._v("41")])]), _vm._v(" A massive flood rerouted it south to San Pedro Bay in 1825, cutting a new channel through wetlands. In the early twentieth century, the harbor was developed to house the ports. After a major flood in 1938, USACE oversaw construction to channelize the river (contain it within a fifty-one-mile cement channel), begun in 1938 and completed in 1960; this dried up wetlands and spared growing urban settlements from future flooding, but the river was never navigable by ship, even after it was contained."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en49",
      "id": "en49r",
      "role": "doc-noteref"
    }
  }, [_vm._v("42")])]), _vm._v(" (This is part of a global story: over the twentieth century, wetlands areas totaling the size of Canada were drained and dried worldwide."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en50",
      "id": "en50r",
      "role": "doc-noteref"
    }
  }, [_vm._v("43")])]), _vm._v(") Before the river was channelized, the area was indeed tidal flats, useless"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en51",
      "id": "en51r",
      "role": "doc-noteref"
    }
  }, [_vm._v("44")])]), _vm._v(" or no: “Each estuary contained on its shoreward margin areas of sand bars and thinly vegetated dunes. Low tide left the flats and marshes as dry and contiguous land, only interrupted by narrow channels of sub-tidal water. High tide, however, inundated and fractured the interior into a collection of islands, shoals, and open water.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en52",
      "id": "en52r",
      "role": "doc-noteref"
    }
  }, [_vm._v("45")])]), _vm._v(" On the western side of the bay toward the Palos Verdes peninsula were two islands, Dead Man’s Island (since removed in dredging the harbor) and Rattlesnake Island (now Terminal Island, and utterly transformed by infill). Rattlesnake Island was more a spit of sand protecting the wetlands from the open water than an island in the sense of rock formations."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en53",
      "id": "en53r",
      "role": "doc-noteref"
    }
  }, [_vm._v("46")])]), _vm._v(" Dead Man’s Island bore its name because some casualties from an 1846 military engagement at Rancho San Pedro, part of the Mexican-American War, were buried there."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en54",
      "id": "en54r",
      "role": "doc-noteref"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', [_vm._v("Around the turn of the twentieth century, Northern California had an active marine research station run by Stanford University, and some in Southern California considered siting an equivalent station in the LA River mouth. Southern California was an ideal site for marine research; in addition to the diversity of life supported by the estuarial land, deep ocean could be reached only a few miles offshore. Headed by biologist and University of California professor William Ritter, a marine research station was established on Terminal Island and operated between 1901 and 1903."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en55",
      "id": "en55r",
      "role": "doc-noteref"
    }
  }, [_vm._v("48")])]), _vm._v(" The islands’ other occupants included fisherfolk and squatters: a contemporary source wrote that “the squatter community is made up of hard-working people, mechanics, longshoremen, boat builders, shop keepers, machinists, artists, clam diggers, fishermen, and a stray scientist or two.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en56",
      "id": "en56r",
      "role": "doc-noteref"
    }
  }, [_vm._v("49")])]), _vm._v(" Some of them collected fossil specimens to sell to scientists and amateur collectors; "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "p9",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the island areas were rich with fossil specimens, as the same geologic processes that had produced oil in this location also resulted in fossils. But in 1912, the squatters were evicted so the port could be built up.")]), _vm._v(" "), _c('p', [_vm._v("Whether the massive ports would be sited in San Pedro Bay was a matter of controversy. According to Tejani, “while the Los Angeles region held many natural resources to support settlement, it lacked environmental conditions to support modern maritime transportation and to provide a hub for commercial and industrial growth.” In particular, the greater Los Angeles coastline did not naturally support a deep-water port (unlike San Diego, San Francisco, and Puget Sound), and the lack of navigable riverways meant it was nearly as beholden to railroad power as a landlocked town. As noted above, some envisioned the bay and rich estuarial environs as a site for marine research; historical ecologists estimate that the combined estuaries of the Los Angeles coastline once totaled between fifteen thousand and eighteen thousand acres."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en57",
      "id": "en57r",
      "role": "doc-noteref"
    }
  }, [_vm._v("50")])]), _vm._v(" Railroad interests jockeyed for favorable positions in rail-port linkages; for example, railroad baron Collis Huntington sought to site the port in Santa Monica, on the western edge of Los Angeles, around the other side of the Palos Verdes peninsula, in hopes of maintaining monopoly control of rail lines in San Pedro. Nearby Redondo Beach was also in the running, as it could accommodate large ships in deep water, but high mountain passes to the east restricted rail connections during the winter, and it was also more exposed to storms, facing the open ocean. San Pedro had rail connecting to routes that could ship cargo east more of the year."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en58",
      "id": "en58r",
      "role": "doc-noteref"
    }
  }, [_vm._v("51")])]), _vm._v(" After back and forth between Huntington and his allies, and those promoting San Pedro, San Pedro was selected as the site for LA’s main port ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0008#fig4"
    }
  }, [_vm._v("fig. 4")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en59",
      "id": "en59r",
      "role": "doc-noteref"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', [_vm._v("That there would be a massive port "), _c('i', [_vm._v("somewhere")]), _vm._v(" in Southern California was not, however, a matter of debate. Business leaders agreed that an expanded port was necessary to participate in growing trade enabled by and exemplified in the Panama Canal, the construction of which the United States oversaw beginning in 1904 (and under US administration for the entire twentieth century before being returned to Panama in 1999)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en60",
      "id": "en60r",
      "role": "doc-noteref"
    }
  }, [_vm._v("53")])]), _vm._v(" Los Angeles would need a deep-water port to connect its business center and its harbor to expanded international shipping."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en61",
      "id": "en61r",
      "role": "doc-noteref"
    }
  }, [_vm._v("54")])]), _vm._v(" Leaders of the US armed forces, fresh off armed conflict in the Philippines, also saw in Los Angeles’s waterfront a means of American expansion into the Pacific realm."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en62",
      "id": "en62r",
      "role": "doc-noteref"
    }
  }, [_vm._v("55")])]), _vm._v(" The only issue was where to locate a major port. Though Ritter had at one time declared his certainty that Rattlesnake (Terminal) Island would be the place for a permanent marine laboratory, he later pursued San Diego sources of funding, in part because he feared the Los Angeles harbor would grow in commercial importance, impinging on the site’s ability to support "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "10",
      "epub:type": "pagebreak",
      "id": "p10",
      "role": "doc-pagebreak"
    }
  }), _vm._v("marine research. Founded as the San Diego Marine Biological Association in 1903, the present-day internationally renowned Scripps Institution for Oceanography in La Jolla is testament to his successful fundraising outside of LA."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en63",
      "id": "en63r",
      "role": "doc-noteref"
    }
  }, [_vm._v("56")])]), _vm._v(" Decisions made in this period cemented the San Pedro harbor as a major industrial site in greater Los Angeles and, indeed, in North America ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0008#fig5"
    }
  }, [_vm._v("fig. 5")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig4"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p10"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "507",
      "src": "images/chi-dunbarhester-004.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 4.")]), _vm._v(" Diagram showing manipulated, infilled coastline and breakwaters overlaid onto 1872 map. From Reish and Soule 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "figatr"
  }, [_vm._v("© Biologische Anstalt Helgoland/ BioMed Central Ltd; used with permission.")])])]), _vm._v(" "), _c('p', [_vm._v("San Pedro Bay was the site of the ports of Long Beach and Los Angeles before the “discovery” of oil slightly inland (the Long Beach Oil Field) and adjacent and underneath (the Wilmington Oil Field), but only just barely. California had been an oil-producing state prior to the industrial development of the harbor. But the discovery of one of the most productive oil fields in the world in 1921, in Signal Hill (an unincorporated patch of land surrounded by Long Beach, a few miles inland from the ports), happened at a time when oil was becoming more valuable nationally, as easterners in the United States were turning to oil for heating and railroads were turning to it for fuel; in addition, automobiles were becoming more plentiful and elevating demand for fuel."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en64",
      "id": "en64r",
      "role": "doc-noteref"
    }
  }, [_vm._v("57")])]), _vm._v(" Signal Hill was the richest oil deposit in the world in terms of barrels per acre."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en65",
      "id": "en65r",
      "role": "doc-noteref"
    }
  }, [_vm._v("58")])]), _vm._v(" Southern California’s oil boom appears "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "11",
      "epub:type": "pagebreak",
      "id": "p11",
      "role": "doc-pagebreak"
    }
  }), _vm._v("in novelized form in Upton Sinclair’s "), _c('i', [_vm._v("Oil!")]), _vm._v(", published in 1926 and also the inspiration for the 2007 film "), _c('i', [_vm._v("There Will Be Blood")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0008#fig6"
    }
  }, [_vm._v("fig. 6")]), _vm._v(").")]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig5"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p11"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "337",
      "src": "images/chi-dunbarhester-005.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 5.")]), _vm._v(" Present-day aerial shot of the Port of LA and coastline.")]), _vm._v(" "), _c('p', {
    staticClass: "figatr"
  }, [_vm._v("Courtesy Port of Los Angeles.")])])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig6"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p11"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "255",
      "src": "images/chi-dunbarhester-006.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 6.")]), _vm._v(" Oil derricks in coastal Huntington Beach, 1920s. Slightly south of San Pedro Bay, this is near where an undersea oil pipeline burst in October 2021.")]), _vm._v(" "), _c('p', {
    staticClass: "figatr"
  }, [_vm._v("Used with permission from Orange County Archives.")])])]), _vm._v(" "), _c('p', [_vm._v("In 1932, the petroleum industry first tapped the Wilmington Oil Field, in the harbor’s immediate vicinity. Soon, oil companies, city officials, and the Los Angeles Harbor Department recognized that the harbor itself contained oil, under the land under the water (but note that what is water and what is land are, definitionally, somewhat fluid here, as both human and natural forces have made and remade the harbor). This led to conflict with the State of California, which claimed that Long Beach had been given permission to develop the harbor as a port but not as an oil field; the original “tidelands grant” did not permit land use for oil extraction."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en66",
      "id": "en66r",
      "role": "doc-noteref"
    }
  }, [_vm._v("59")])]), _vm._v(" Nonetheless, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "12",
      "epub:type": "pagebreak",
      "id": "p12",
      "role": "doc-pagebreak"
    }
  }), _vm._v("paralleling the development of the ports, the conflicts that ensued were not over whether oil would be extracted in this site but who would oversee and reap profit from it.")]), _vm._v(" "), _c('p', [_vm._v("Though it is now off its high-water (high-oil?) mark of midcentury drilling, it is nearly impossible to overstate the presence of petroleum in San Pedro Bay. In addition to the inland and tidal basin drilling, offshore oil extraction commenced in the 1950s. At this time, man-made “oil islands” were built in the Long Beach side of the bay. The islands, built of rock from nearby Santa Catalina Island, are drilling platforms that have been modified aesthetically to disguise the industrial activity; a casual visitor to the Long Beach waterfront would not necessarily realize the islands contain oil wells, let alone that this is why the islands are there in the first place. The port facilities are connected to massive oil refining operations, barely inland: infrastructure including ship-to-shore pipelines allowing crude oil to be moved directly on or off ships and into storage and refining facilities. Though diminished since its twentieth-century heyday, some extraction still occurs within and around the edges of the port complex as well. Sun-faded pumpjacks languorously sip oil up from underground while others stand completely idle, bleak metal skeletons. According to Port of Long Beach spokesperson Mario Gonzalez, if the port were to shut down, Southern California would run out of oil in about five days."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en67",
      "id": "en67r",
      "role": "doc-noteref"
    }
  }, [_vm._v("60")])]), _vm._v(" Petroleum has been the Port of Long Beach’s biggest import and export for decades, according to annual reports. And Southern California is not an outlier here: crude oil, transported in tankers, constitutes around 30 percent of all maritime cargo globally ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chidunbarhester0008#fig7"
    }
  }, [_vm._v("fig. 7")]), _vm._v(")."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en68",
      "id": "en68r",
      "role": "doc-noteref"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('figure', {
    staticClass: "figure",
    attrs: {
      "id": "fig7"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p13"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "399",
      "src": "images/chi-dunbarhester-007REPLACEMENT-7-21-22-2.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figh"
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("Figure 7.")]), _vm._v(" Oil tanker, Long Beach Harbor, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "figatr"
  }, [_vm._v("Photo by McKenzie Stribich.")])])]), _vm._v(" "), _c('p', [_vm._v("Increasingly, as coastal reserves have been tapped and regulations and public opposition have made it harder to site new wells coastally, California fossil fuel production has moved inland, less in view for coastal residents and recreationists. (Major spills in Santa Barbara and San Francisco around 1970 led to public opposition to new coastal drilling.) Nonetheless, the refining and transport functions of the port complex are significant, even if extraction is sited further away. The Los Angeles harbor was, by the early 1930s, a “petroleumscape”: “Port cities are the quintessential petroleumscapes, where the physical presence of oil infrastructure—storage tanks, pipelines, shipping facilities—overlaps with oil-related administrative and cultural functions,” writes architecture and planning scholar Carola Hein."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en69",
      "id": "en69r",
      "role": "doc-noteref"
    }
  }, [_vm._v("62")])]), _vm._v(" Invisible though it may be from other vantage points in greater LA, the Los Angeles harbor made a long-term, fixed investment in petroleum decades ago, and that commitment remains to this day."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en70",
      "id": "en70r",
      "role": "doc-noteref"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', [_vm._v("Oil literally fueled trade, another major harbor operation. It both powered ships and drove the generation of wealth. By midcentury, port "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "p13",
      "role": "doc-pagebreak"
    }
  }), _vm._v("managers and other officials moved to reinvest oil wealth in further building up shipping infrastructure."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en71",
      "id": "en71r",
      "role": "doc-noteref"
    }
  }, [_vm._v("64")])]), _vm._v(" In Los Angeles’s harbor, this was a local and regional decision, but it was simultaneously notched into a national economy and a global system. Trade ramped up in the economic boom after World War II; managers in this harbor and others decided to invest in the technological innovations of containerized shipping and expanded dredging capacity."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en72",
      "id": "en72r",
      "role": "doc-noteref"
    }
  }, [_vm._v("65")])]), _vm._v(" The Los Angeles–Long Beach port complex is an infrastructural node within a system of global trade. As scholar of international politics Laleh Khalili writes, maritime trade, logistics, and hydrocarbon transport “are the clearest distillation of how global capitalism operates today.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en73",
      "id": "en73r",
      "role": "doc-noteref"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', [_vm._v("As noted above, US imperial expansion into the Pacific had happened by the turn of the nineteenth century, including occupation of the Philippines and annexation of Hawai‘i. After World War I, American naval power became concentrated in the Pacific rather than the Atlantic. A fort had already been sited on the Palos Verdes peninsula by the early twentieth century. Unsurprisingly, World War II saw the further buildup of US military power in the harbor. The navy undertook infrastructure projects in the harbor, building a naval station and a shipyard, and expanding breakwaters to allow for miles of protected shoreline (reaching nearly to Orange County, all across San Pedro Bay and the Long Beach shoreline)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en74",
      "id": "en74r",
      "role": "doc-noteref"
    }
  }, [_vm._v("67")])]), _vm._v(" After the Japanese attack on Pearl Harbor in December 1941, Los Angeles blacked out its harbor to remove it as a target, and the harbor was considered a defensive "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "p14",
      "role": "doc-pagebreak"
    }
  }), _vm._v("stronghold through World War II. For a brief moment after the war, it looked as though the navy might draw down its personnel and equipment, but when the United States entered the Korean War, it opted to maintain a navy presence in the harbor, and many naval vessels “homeported” there through the Korean and Vietnam Wars. In the 1990s, the navy did finally relinquish some of its space in the harbor, shuttering a base and naval hospital; its space was then converted to commercial shipping use. However, the US military is still very much present: it uses Seal Beach on the far side of San Pedro Bay for fueling and for a weapons station, and the navy consolidated its Southern California presence further south in San Diego County. Finally, oil and the military are intimately linked in myriad ways, especially through ideologies of national security through energy independence and through the US military’s heavy reliance on fossil fuel.")]), _vm._v(" "), _c('p', [_vm._v("Of course, the history of this land and marine area does not begin with USACE’s and Los Angeles business magnates’ decision to build massive industrial infrastructure. The prehistory of the tidal flats includes the 1825 flood rerouting the LA River, Mexican rule, Spanish colonial settlement, and indigenous settlement by humans, animals, and plants prior to that. But the transmutation that the siting of the port complex accomplished is significant, as it locked in a series of commitments, which inarguably changed the area massively in a very short time.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro03"
    }
  }, [_vm._v("Ecology, Violence, and Flux in San Pedro Bay")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("It is not my aim to tell the entire history of the port complex and surrounding estuarial/ecotone zone over the last half-century or so, nor is this necessarily even possible. Rather, the stories here prioritize a handful of themes that help to reveal meaningful developments in San Pedro Bay. They help to make sense of a local story and how it fits into much bigger global patterns. The Los Angeles harbor is itself a truly massive site, taking into account not only the square footage of its land and water, and tons of concrete and steel, but also the complex technopolitical systems and knowledge that run through it. In other words, the port complex is not just a collection of objects or systems but a large assemblage in an even more vast, heterogeneous, and intricate sociotechnical system that is both deadly and lively. I do not mean to suggest the ports of Los Angeles and Long Beach are especially singular or unique in this context; they merely constitute a node in a global system. At the same time, this book insists on approaching this vast assemblage as a local site, through resolutely partial and even provincial stories.")]), _vm._v(" "), _c('p', [_vm._v("Shocking 2018 reports indicated that 60 percent of vertebrate species "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "p15",
      "role": "doc-pagebreak"
    }
  }), _vm._v("have been lost worldwide since 1970, mainly through decimation of biodiverse rain forest."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en75",
      "id": "en75r",
      "role": "doc-noteref"
    }
  }, [_vm._v("68")])]), _vm._v(" With each subsequent tally, the global “outlook [for biodiversity] gets worse.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en76",
      "id": "en76r",
      "role": "doc-noteref"
    }
  }, [_vm._v("69")])]), _vm._v(" We are experiencing a major extinction event and multiple ecocides."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en77",
      "id": "en77r",
      "role": "doc-noteref"
    }
  }, [_vm._v("70")])]), _vm._v(" This book insists, perhaps counterintuitively, on thinking about multitudinous life within a hyperindustrialized, highly managed site. The port complex is sited in an area that is home or way station to a multitude of life-forms. Some of these creatures were nearly exterminated in earlier eras and are seeing their populations rebound somewhat due to legal protections and conservation efforts. Yet their fragile gains are happening against a backdrop of rapid and dramatic climate crisis, which is deeply stressing planetary systems and throwing heretofore taken-for-granted conditions for life into question. Meanwhile extraction, trade, and consumption march (drill, dredge, pave) along, imbued with a logic of expansion and resilience. I call the latter infrastructural vitalism and juxtapose it with organismic ecologies.")]), _vm._v(" "), _c('p', [_vm._v("Infrastructural vitalism is the premise for a global system that drives violence and lethality. In October 2021, when a seabed oil pipeline off the coast of Orange County burst, it fouled water and coastline during the autumnal Pacific Flyway migration. The pipeline connected drilling in the seabed to the port of Long Beach. Amid global supply-chain chaos and while dozens of ships crowded the coastline near the harbor, waiting their turns to dock in the ports, a cargo ship’s anchor had likely struck and dragged the pipeline. Tar showed up on beaches as far south as San Diego County. Some in the region revisited commitments made in the 1970s; a journalist noted that, even at that time, “selling offshore leases for oil drilling in the middle of shipping lanes seemed reckless.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en78",
      "id": "en78r",
      "role": "doc-noteref"
    }
  }, [_vm._v("71")])]), _vm._v(" It is overwhelmingly clear which priorities this infrastructure supports: petroleum and goods movements at scale. In spite of local conservation efforts, because of how the port complex connects commodity chains and labor across the globe, it can arguably even be said to participate in habitat loss and even ecocide well outside the borders of San Pedro Bay."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en79",
      "id": "en79r",
      "role": "doc-noteref"
    }
  }, [_vm._v("72")])]), _vm._v(" The endless growth that infrastructural vitalism demands is both practically and morally hazardous. Birds make charismatic victims, but they are not the only ones.")]), _vm._v(" "), _c('p', [_vm._v("The port complex in San Pedro Bay is implicated in capitalist, colonial relations. Even as it creates wealth, capitalist expansion is destructive. In fact, destruction is a precondition of expansion; it is built into the cycle. As geographer David Harvey writes, a central contradiction of capital is that it “has to build a fixed space or landscape necessary to its own functioning at a certain point in history only to have to destroy that space (and devalue much of the capital therein) at a later point in order to have to make way for a new spatial fix (openings for fresh accumulations and territories) at "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "p16",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a later point in its history.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en80",
      "id": "en80r",
      "role": "doc-noteref"
    }
  }, [_vm._v("73")])]), _vm._v(" In the port complex, a fixed-capital commitment to petroleum was cemented by the 1930s. This was necessary to accumulate wealth through oil extraction and trade on a continuous basis. Such activities perpetuate ecological damage at extraction sites, of course. But the kind of destruction Harvey draws attention to here is different: in an eventual crash of the value of petroleum, the value of the commodity itself will be destroyed, and moreover the value of the investment sunk into petroleum "), _c('i', [_vm._v("infrastructure")]), _vm._v(" (the refineries, the pipelines, etc.) will also be destroyed, if and when an energy transition occurs. This will leave the port complex, built up to process and transport petroleum, as a ruin: a toxic ghost of capitalist expansion and subsequent abandonment. Capitalism, if unchecked, will meanwhile merrily and wantonly go on to fresh accumulations, territories, and acts of destruction: lithium (a key ingredient in batteries for electric vehicles) is in the upswing part of this cycle at present."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en81",
      "id": "en81r",
      "role": "doc-noteref"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', [_vm._v("Capitalism is a dominant economic system, but its tendency toward expansion is enhanced by the seizure of land and natural resources, often in lockstep with colonialism. Capitalism allows for the enclosure of natural resources to promote wealth accumulation, but the colonial project also claims space to pollute, to discard waste (a by-product of capitalist commodification processes)."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en82",
      "id": "en82r",
      "role": "doc-noteref"
    }
  }, [_vm._v("75")])]), _vm._v(" In San Pedro Bay, the lives I survey in this book are all characterized by having relationships to commodification "), _c('i', [_vm._v("and")]), _vm._v(" by being implicated in processes of territorialization, that is, colonialist projects. I take as axiomatic that the land claim processes of settler colonialism structure relations in San Pedro Bay. In this site, it is especially important to note that in the context of goods movement, meaningful distinctions between “civilian” and “military” collapse. Movement of goods and management of space and lives (of people, of wildlife, of stuff, and certainly of oil) is an imperial project as well as a capitalist one. “Protecting trade networks from disruption creates new spaces of security and in doing so problematizes the political and legal status of subjects,” writes geographer Deborah Cowen."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en83",
      "id": "en83r",
      "role": "doc-noteref"
    }
  }, [_vm._v("76")])]), _vm._v(" Finally, though it is particularly easy to see how the conjoinment of capitalism and colonialism produces degraded organismic ecologies (often hideously so), other political and economic systems can as well. Infrastructural vitalism is potentially flexible enough to accompany multiple systems of extraction and expansion."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en84",
      "id": "en84r",
      "role": "doc-noteref"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', [_vm._v("Capitalist expansion is "), _c('i', [_vm._v("violent")]), _vm._v(", in a literal sense. This book introduces the reader to life-forms that live within and transit through the port complex that have been harmed, directly and indirectly, through industrial commodification processes. California sea otters were hunted to near extinction for their pelts centuries ago. Gray whales were hunted for blubber: the eastern Pacific population off the coast of North America is relatively "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "p17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("stable, but their Atlantic cousins are gone, and their western Pacific siblings are quite imperiled. Least terns were hunted for decorative feathers. Seabirds, cetaceans, and otters, meanwhile, can also be maimed and killed by spilled oil and other forms of industrial violence, from fishing nets to agricultural runoff."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en85",
      "id": "en85r",
      "role": "doc-noteref"
    }
  }, [_vm._v("78")])]), _vm._v(" In these instances, they are merely collateral damage in the commodification of another substance (petroleum, which used to be lives) or other lives (agricultural crops; commercial fishing). Banana importation consumes petroleum fairly intensively and leaves in its wake a plume of chemicals (and political relations) harmful to laborers and to wildlife."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en86",
      "id": "en86r",
      "role": "doc-noteref"
    }
  }, [_vm._v("79")])]), _vm._v(" And ship strikes constitute a prominent risk to whales; their bodies can be in the wrong place at the wrong time with regard to goods movement. Though spilled oil can be a media event, more often violence is not especially spectacular or cataclysmic but the slow accumulation of injury and multiplication of harm."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en87",
      "id": "en87r",
      "role": "doc-noteref"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', [_vm._v("But life has tendencies of its own: it multiplies itself. Life can regenerate, and mutate. The point is, life inherently contains the ability to create more of itself (and sometimes plays a supporting role in the multiplicative efforts of other life-forms through mutualisms). For lives recently placed in the shadow of the port complex, there has been a tendency to accumulate more life, over eons."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en88",
      "id": "en88r",
      "role": "doc-noteref"
    }
  }, [_vm._v("81")])]), _vm._v(" Capitalism is set to accumulation as well, and this explains its harm to life at scale: capitalism tends to claim for commodification the capacity of life to generate more of itself, or it seeks accumulation of resources in landscapes where life dwells rapidly and often very destructively. For collectivities of organisms suffering under the burden of cumulative industrial injury, life’s tendency to accumulate can serve as a counterweight, but only to a point. Given the destructive power we are witnessing, we might wonder, what if global systems could be set to accumulate not wealth, but life?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en89",
      "id": "en89r",
      "role": "doc-noteref"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', [_vm._v("Organisms have generative and dynamic tendencies, and so do ecological systems more broadly. Even in spite of the (recent) constancy of the port complex and the obduracy of its construction, the harbor is in a state of "), _c('i', [_vm._v("flux")]), _vm._v(". After San Pedro Bay became the mouth of the Los Angeles River, the “useless tidal flats” were constantly made and remade with tides and storms. Upon identifying the area for a project of infrastructural fixity, managers built breakwaters and docks and then petroleum infrastructure.")]), _vm._v(" "), _c('p', [_vm._v("Silt might be the most obvious example of flux. To create a harbor suitable for ship traffic, the coastline needed to be dredged. Indeed, in the period when officials decided to site a major port in Los Angeles, LA lacked “what observers universally considered the essential component of a commercial metropolis: a natural deep-water harbor and anchorage.” "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "p18",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Overcoming this obstacle to building a large port required using then-new hydraulic dredges to remake the coastline."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en90",
      "id": "en90r",
      "role": "doc-noteref"
    }
  }, [_vm._v("83")])]), _vm._v(" Dredging is absolutely key to thinking about global trade at scale. Anthropologist Ashley Carse suggests that much globalization of commerce has actually happened “below the waterline”: the environment itself becomes infrastructure."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en91",
      "id": "en91r",
      "role": "doc-noteref"
    }
  }, [_vm._v("84")])]), _vm._v(" But of course silt replenishes itself. For working port infrastructure, it has to be continually dredged away, not only to allow bigger ships needing deeper channels but simply to maintain open shipping channels at all.")]), _vm._v(" "), _c('p', [_vm._v("Land above water is also in flux. (More accurately, what is “land” and what is “underwater” is variable and contingent.) By the 1940s, oil extraction here had produced wealth and an unintended consequence: significant land subsidence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en92",
      "id": "en92r",
      "role": "doc-noteref"
    }
  }, [_vm._v("85")])]), _vm._v(" In fact, Long Beach was called the “Sinking City,” because oil and gas extraction caused land subsidence, up to twenty-nine feet deep at the center of the “subsidence bowl,” afflicting the port area and coastal strand going south and east toward Seal Beach."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en93",
      "id": "en93r",
      "role": "doc-noteref"
    }
  }, [_vm._v("86")])]), _vm._v(" There was also a severe earthquake in Long Beach in 1933, which is now assumed to have been triggered by extraction. By the late 1950s, under threat from federal lawsuits, port engineers implemented a water injection program to repressurize the area, flooding the emptied underground oil field with seawater. This worked to stabilize the land, and regulators were pleased enough with the result that they dropped their suit."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en94",
      "id": "en94r",
      "role": "doc-noteref"
    }
  }, [_vm._v("87")])])]), _vm._v(" "), _c('p', [_vm._v("In an “envirotechnical” space like a harbor, even fixed commitments require maintenance and upkeep to respond to flux."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en95",
      "id": "en95r",
      "role": "doc-noteref"
    }
  }, [_vm._v("88")])]), _vm._v(" Definitionally, there are human-made and natural forces exerting pressures of various sorts on the infrastructure at all times. In the present day, port managers the world over are eyeing climate change, including more intense storms and sea level rise. Sea level rise is, of course, caused by warming. Polar ice is melting even faster than anticipated due to runaway carbon emissions. Planetary systems are veering off course, and meanwhile we are living through a confusing moment with regard to energy. Experts agree that fossil fuel consumption needs to be halted immediately (especially by rich countries) in order to stave off the worst effects of the climate crisis, which are becoming more evident and more severe with each passing year. Due to interruptions to global trade during the initial stage of the coronavirus pandemic, the price of oil futures fell in 2020, reaching negative levels that April before recovering."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en96",
      "id": "en96r",
      "role": "doc-noteref"
    }
  }, [_vm._v("89")])]), _vm._v(" And yet, even as many predict the demise of fossil fuels and seek to hasten a major energy transition, in many territories across the globe, energy companies and states are falling over themselves to drill. US energy companies in particular are currently doubling down on their commitments to extraction, even as some other fossil fuel firms invest "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "p19",
      "role": "doc-pagebreak"
    }
  }), _vm._v("significant resources in alternative energy research and development."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en97",
      "id": "en97r",
      "role": "doc-noteref"
    }
  }, [_vm._v("90")])]), _vm._v(" As of 2020, as the Trump administration was ending, the United States was a net exporter of petroleum (though most regions, including California, were net importers). This was in part a result of expanded hydraulic fracturing (“fracking”) authorized under the Obama administration. According to the US Energy Information Administration, this was the first time the United States had been a net petroleum exporter since recordkeeping began in 1973."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en98",
      "id": "en98r",
      "role": "doc-noteref"
    }
  }, [_vm._v("91")])]), _vm._v(" Petroleum remains a significant priority for the Biden administration. Of course, energy is important in trade, but it is also held to be a major concern for national security, so energy transitions will have multiple complex implications at geopolitical levels."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en99",
      "id": "en99r",
      "role": "doc-noteref"
    }
  }, [_vm._v("92")])]), _vm._v(" If and when fossil fuel as an energy regime falls, the port complex and San Pedro Bay will be ripe for transformation, but the future is murky and still extremely oily for the time being, by bipartisan consensus.")]), _vm._v(" "), _c('p', [_vm._v("All of this is to say that flux, both controlled and otherwise, is endemic. A lingering question about the Los Angeles harbor is who or what is in control. Regional officials and port managers have sought to capitalize on trade opportunities as an economic strategy, with significant booms in growth in the 1960s, 1990s, and 2020s."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en100",
      "id": "en100r",
      "role": "doc-noteref"
    }
  }, [_vm._v("93")])]), _vm._v(" Yet local control can be elusive, in a sense, as officials respond to capital’s complex currents, which take cues from forces well out of the control of economic advisers in Los Angeles County."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en101",
      "id": "en101r",
      "role": "doc-noteref"
    }
  }, [_vm._v("94")])]), _vm._v(" The life-forms in this book all live (or attempt to) in the spaces opened up for them within control—of wildlife, of landscape, of supply chains, of trade patterns. Their ability to do so is in uneasy tension with an infrastructural vitalism that drives extraction and circulation regimes, pushing planetary boundaries to their limits.")])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahintro04"
    }
  }, [_vm._v("The Multispecies, the Human, and the Nonhuman")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Recently it has become common for scholarship in critical humanistic fields to address the nonhuman (commonly called the more-than-human) and to orient toward multispecies accounts."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en102",
      "id": "en102r",
      "role": "doc-noteref"
    }
  }, [_vm._v("95")])]), _vm._v(" I am heavily indebted to research in those modes but, at the same time, the acknowledgment that nonhuman life-forms matter and participate in the world does not necessarily resolve epistemic, analytical, and political problems. Researchers still need to account for specific historical and contemporary formations and how power shapes them. To exalt the nonhuman or more-than-human through “turning” toward it may do a disservice to analysis because the categories are simply not stable enough, and much is at stake. There are common instances of humans and other life-forms being different as a matter "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "p20",
      "role": "doc-pagebreak"
    }
  }), _vm._v("of legal status, of course, but this boundary always is a situated historical accomplishment, not an a priori difference."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en103",
      "id": "en103r",
      "role": "doc-noteref"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', [_vm._v("This matters in at least two ways. First, throughout the history of the West and specifically in the settler colonial legal regime of the United States, not all humans have been equally or universally human, that is, in racial capitalism and projects of colonial domination, “humans” have been sorted into “full humans; not-quite-humans; and nonhumans.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en104",
      "id": "en104r",
      "role": "doc-noteref"
    }
  }, [_vm._v("97")])]), _vm._v(" The processes of “splitting” humans from “others” have “engender[ed] a lot of violence.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en105",
      "id": "en105r",
      "role": "doc-noteref"
    }
  }, [_vm._v("98")])]), _vm._v(" As this book is centrally concerned with showing how the stewardship of San Pedro Bay aligns in many ways with capitalistic and US imperial (including settler colonial) pursuits, it needs to acknowledge how complex both anthropocentrism and systems of oppression are, and how attempts to contest both together do not always neatly align."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en106",
      "id": "en106r",
      "role": "doc-noteref"
    }
  }, [_vm._v("99")])]), _vm._v(" A human-nonhuman binary masks that history and present, conflating and universalizing humans "), _c('i', [_vm._v("and")]), _vm._v(" consolidating a “generic animal.” A more nuanced approach, in the words of literary and Black studies scholar Zakiyyah Jackson, might interrogate both categories and identify “shared being with the nonhuman without suggesting that some members of humanity bear the burden of ‘the animal.’”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en107",
      "id": "en107r",
      "role": "doc-noteref"
    }
  }, [_vm._v("100")])]), _vm._v(" Second, not all humans have been equally responsible for imposing conditions of violent domination on “others” (other people, other life-forms, and terrestrial formations from rivers to veins of coal and cobalt), so blaming “humans” for ecological degradation, for example, obscures power relations and responsibilities."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en108",
      "id": "en108r",
      "role": "doc-noteref"
    }
  }, [_vm._v("101")])]), _vm._v(" Furthermore, politicizing “animality” does not "), _c('i', [_vm._v("necessarily")]), _vm._v(" unseat structuring relations that perpetuate ecological violence."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en109",
      "id": "en109r",
      "role": "doc-noteref"
    }
  }, [_vm._v("102")])]), _vm._v(" In this text, when I refer to humans, I place them on continuum with other life-forms—all of whom shape, cocreate, and respond to conditions of mutualism and domination, by turn. In this site, specific epistemic, political, and economic commitments have been given disproportionate power to shape the lives (and deaths) of a host of creatures, and one in particular—a commitment to infrastructural vitalism—is the structuring force that I draw out in this multispecies analysis.")]), _vm._v(" "), _c('p', [_vm._v("Ultimately, of course, infrastructural vitalism was conjured by "), _c('i', [_vm._v("agents of capitalism and colonialism")]), _vm._v(", and landscape management is racialized on the coast and elsewhere. Writing of Northern California in the nineteenth century, geographer Lindsay Dillon shows that inland swamp reclamation transformed “waste” land into “productive” space subject to fixed property regimes (not dissimilarly from the Port of Long Beach managers’ boast in 1971). “Civilizing” the swampland secured it for whites’ health and economic gain; and swamp-clearing utilized racialized labor."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en110",
      "id": "en110r",
      "role": "doc-noteref"
    }
  }, [_vm._v("103")])]), _vm._v(" Following on "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "21",
      "epub:type": "pagebreak",
      "id": "p21",
      "role": "doc-pagebreak"
    }
  }), _vm._v("the heels of Indigenous dispossession, landscape transformation produced settler ecologies that articulated with emerging racial formations, which persist into the present."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en111",
      "id": "en111r",
      "role": "doc-noteref"
    }
  }, [_vm._v("104")])]), _vm._v(" Racialized coastal management can be seen in myriad ways in present-day San Pedro Bay: in the ports’ economic and labor logics; in whites’ claims to the coast for recreation, including yachting, surfing, and restored coastal wetlands like the Dominguez Gap; and on Terminal Island, which houses a federal prison, itself infrastructure for racialized securitization and enclosure."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en112",
      "id": "en112r",
      "role": "doc-noteref"
    }
  }, [_vm._v("105")])]), _vm._v(" Infrastructural vitalism subjects biological life-forms spanning humans and nonhumans to violence, but as much as possible I refer to living creatures by labels at the level of species groups and social groups.")]), _vm._v(" "), _c('p', [_vm._v("Speaking of species, one trade-off in this account is that I treat quite a few terms and concepts in this book as though they are static, even though they are in fact lively and often contested. A different analysis would get "), _c('i', [_vm._v("inside")]), _vm._v(" some of the controversies that attend concepts from natural sciences like biodiversity; species; endangerment; conservation, a “self-declared ‘crisis discipline’”; and, last but not least, “biological life” itself."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en113",
      "id": "en113r",
      "role": "doc-noteref"
    }
  }, [_vm._v("106")])]), _vm._v(" Using these terms and especially treating them as fairly settled concepts draws me into engagement with findings from scientific research, but it is not my intent to uncritically center or reproduce the authority of scientific knowledge."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en114",
      "id": "en114r",
      "role": "doc-noteref"
    }
  }, [_vm._v("107")])]), _vm._v(" I certainly do not mean to imply that the Western natural sciences offer the only, let alone the best, account of biological life. At the same time, work in these disciplines has effects in the world, informing landscape and wildlife management. This work shapes both my own knowledge and popular representations of the lives and spaces of multispecies dwelling, which needs to be acknowledged, especially as it is a goal of this book to cultivate recognition of some “intimate particularities” of multispecies lives as they dwell and die."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en115",
      "id": "en115r",
      "role": "doc-noteref"
    }
  }, [_vm._v("108")])])]), _vm._v(" "), _c('p', [_vm._v("Finally, my focus on “charismatic species” is both an asset and liability."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en116",
      "id": "en116r",
      "role": "doc-noteref"
    }
  }, [_vm._v("109")])]), _vm._v(" On the one hand, this can reproduce some of the problems with the species concept in conservation: it can lead to “typological essentialism,” treating the differences between individuals as insignificant in order to render them as equivalent in terms of species-identity; it can draw attention away from ecologies, mutualisms, and patterns of relationality; and it can underrepresent the needs and significance of noncharismatic species, leading toward heroic measures to save individual creatures or species at the cost of overlooking habitats and dynamic ecologies."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en117",
      "id": "en117r",
      "role": "doc-noteref"
    }
  }, [_vm._v("110")])]), _vm._v(" A more "), _c('i', [_vm._v("natural")]), _vm._v(" natural history might choose, for example, to center algae, gnats, and snails. On the other hand, my approach capitalizes (as it were) on the familiarity of life-forms like birds, whales, and otters. Readers’ assumed acquaintance "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "p22",
      "role": "doc-pagebreak"
    }
  }), _vm._v("with and affection for these creatures can serve different ends here, locating their presences in the port complex especially as they relate to capital and petroleum, in order to draw out infrastructural vitalism. It also has a methodological advantage, allowing engagement with media representations in addition to scientific papers, trade, and gray literature.")]), _vm._v(" "), _c('p', [_vm._v("The chapters that follow all chronicle biological life in and out of commodity chains, while attending to ecological lines of relation, violence, and flux. Biological life in the harbor comes into focus, and species become managed objects of conservation, as a direct result of encounters with industrial practices that also harm them. The production of scientific knowledge in this context supports biological life but also enlivens freight and petroleum infrastructure. Cowen’s work on supply chains as constitutively violent and deadly, even as they are also “lively systems,” is mainly concerned with transnational networks where workers’ lives and bodies are disciplined. But she gestures toward nonhuman migration in logistics and suggests that nonhuman border crossings (of both goods and animals) speak, in some fashion, to the possibility of circulation of oppositional and alternative logics.")]), _vm._v(" "), _c('p', [_vm._v("My project here picks up some of these threads, taking Cowen’s work as a prompt to think with "), _c('i', [_vm._v("liveness, life")]), _vm._v(", and "), _c('i', [_vm._v("liveliness")]), _vm._v(" (as well as death) in relation to the circulation of goods and capital in logistics spaces. In these pages, I surface the persistent (if embattled) lines of biological relationality that circulate in the heavily managed logistics space that is San Pedro Bay. San Pedro Bay is teeming with life-forms, but its harbor is also a site of environmental injury, and a node within a violent world system. The port complex is always in a state of flux, and energy regimes in particular are poised for transformation, but there is little reason to believe that new “clean” energy sources alone will remake local worlds in a fairer image."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en118",
      "id": "en118r",
      "role": "doc-noteref"
    }
  }, [_vm._v("111")])]), _vm._v(" If we understand the port complex as a chokepoint, circulating not only goods but a world system, we might be able to reconceptualize it as a node for “unfixing” the lethal world system of infrastructural vitalism in which it has been implicated for over a century."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en119",
      "id": "en119r",
      "role": "doc-noteref"
    }
  }, [_vm._v("112")])]), _vm._v(" Logistics space is “a tool of imperial dispossession and capitalist power, [but] it also produces new sites of vulnerability and "), _c('i', [_vm._v("potential emancipation")]), _vm._v(",” write geographers Charmaine Chua and coauthors."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en120",
      "id": "en120r",
      "role": "doc-noteref"
    }
  }, [_vm._v("113")])]), _vm._v(" What if the port complex could be imagined as an "), _c('i', [_vm._v("audit point for transspecies supply-chain justice, including labor practices, environmental harm, and resource use")]), _vm._v("?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en121",
      "id": "en121r",
      "role": "doc-noteref"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', [_vm._v("A multispecies analysis of San Pedro Bay can attune us to some of the destructive patterns produced by the movement of capital; and multispecies lives here can even point us to somewhat hopeful stories of life pulled back from the brink. But the annihilative forces of capital expansion "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("mean that the stories cannot be too hopeful; multispecies hope under ascendant infrastructural vitalism is fragile and contingent. Biological life in San Pedro Bay can prompt us to ask: how might we reimagine and retool infrastructures to promote not commodity “chains” but intricate loops, interconnections, and renewed lines of ecological relation?"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chidunbarhester0016#en122",
      "id": "en122r",
      "role": "doc-noteref"
    }
  }, [_vm._v("115")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36db225a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-dunbar-hester-0008.vue
// module id = 75
// module chunks = 0